/**
 * Normalizes a manual citation path for display purposes.
 *
 * Strips the index name and any intermediate folder structure, keeping only
 * the `product-manuals/` prefix, the bare filename, and the page fragment.
 *
 * Examples:
 *   "product-manuals/v1/doc.pdf"                               → "product-manuals/doc.pdf"
 *   "doc.pdf#page=5"                                           → "product-manuals/doc.pdf#page=5"
 */
export function normalizeManualCitationDisplayPath(path: string): string {
    const hashIndex = path.indexOf("#");
    const pathPart = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
    const fragment = hashIndex >= 0 ? path.slice(hashIndex) : "";
    const fileName = pathPart.split("/").filter(Boolean).pop() ?? pathPart;
    return `product-manuals/${fileName}${fragment}`;
}
